import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class RoleService {
  baseUrl = 'role';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = (includeOrganizationAdmin = true) => BaseService.get({ url: `${this.baseUrl}?includeOrganizationAdmin=${includeOrganizationAdmin}` });
  getFunctionRightList = () => BaseService.get({ url: `${this.baseUrl}/function-rights` });
  getUserList = (roleId) => BaseService.get({ url: `${this.baseUrl}/users/${roleId}` });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  save = (role) => BaseService.post({ url: `${this.baseUrl}/save`, data: role });
  getById = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
}

export default new RoleService();
